module.exports = __webpack_public_path__ + "static/media/3.1_preview.830438fa.png";